var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useAsyncEffect } from 'ii-react-sdk/hooks';
import { SimpleErrorModal } from 'ii-react-sdk/modal_components';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { useComparison } from '../../provider';
const DocumentsViewContext = createContext({});
const DocumentsViewProvider = (props) => {
    const { isInitializing, comparisonDocuments } = useComparison();
    const [anchorDoc, setAnchorDoc] = useState(null);
    const [comparatorDoc, setComparatorDoc] = useState(null);
    const [decPageFieldKeys, setDecPageFieldKeys] = useState([]);
    const [clauseKeys, setClauseKeys] = useState([]);
    const [selectedElement, setSelectedElement] = useState(['category', 'descriptor']);
    const [anchorBookmark, setAnchorBookmark] = useState([]);
    const [comparatorBookmark, setComparatorBookmark] = useState([]);
    const [isErrorModalShowing, setIsErrorModalShowing] = useState(false);
    const [errorModalMessage, setErrorModalMessage] = useState('');
    useAsyncEffect(() => __awaiter(void 0, void 0, void 0, function* () {
        if (isInitializing)
            return;
        try {
            if (comparisonDocuments.length < 2)
                throw Error('Comparison requires at least 2 documents');
            setAnchorDoc(comparisonDocuments[0]);
            setComparatorDoc(comparisonDocuments[1]);
        }
        catch (e) {
            console.error(e);
            setErrorModalMessage(e.message);
            setIsErrorModalShowing(true);
        }
    }), [isInitializing, comparisonDocuments]);
    useEffect(() => {
        if (!anchorDoc || !comparatorDoc)
            return;
        const decPageFields = [];
        const clauses = [];
        for (const doc of [anchorDoc, comparatorDoc]) {
            for (const dp of Object.keys(doc.data.decPageFields)) {
                if (!decPageFields.includes(dp))
                    decPageFields.push(dp);
            }
            for (const dp of Object.keys(doc.data.clauses)) {
                if (!clauses.includes(dp))
                    clauses.push(dp);
            }
        }
        setDecPageFieldKeys(decPageFields);
        setClauseKeys(clauses);
    }, [anchorDoc, comparatorDoc]);
    const swapDocs = () => {
        setAnchorDoc(comparatorDoc);
        setComparatorDoc(anchorDoc);
    };
    const value = {
        anchorDoc,
        comparatorDoc,
        setAnchorDoc,
        setComparatorDoc,
        clauseKeys,
        decPageFieldKeys,
        selectedElement,
        setSelectedElement,
        anchorBookmark,
        setAnchorBookmark,
        comparatorBookmark,
        setComparatorBookmark,
        swapDocs,
    };
    return React.createElement(React.Fragment, null,
        React.createElement(DocumentsViewContext.Provider, Object.assign({ value: value }, props)),
        React.createElement(SimpleErrorModal, { isModalShowing: isErrorModalShowing, errorMessage: errorModalMessage }));
};
const useDocumentsView = () => {
    const context = useContext(DocumentsViewContext);
    if (!context) {
        throw new Error('IDocumentsViewContext must be used inside of a DocumentsViewProvider');
    }
    return context;
};
export { DocumentsViewProvider, useDocumentsView, };
